<template lang="pug">
form.form-horizontal
  .form-group(v-for='(item, index) in items')
    label.col-md-12 {{item.label}}
      .col-md-12
      el-input(type='text', :value="value[item.name]",@input="inputData($event, item.name)")
</template>
    
<script>
export default {
  name: 'Top',
  props: ['value'],
  data () {
    return {
      locale_url: {
        ja: '',
        en: '',
        cn: '',
        kr: ''
      },
      items: [
        {
          name: 'data-frames',
          label: 'data-frames'
        },
        {
          name: 'data-videomp4',
          label: 'data-videomp4'
        },
        {
          name: 'data-videopreload',
          label: 'data-videopreload'
        },
        {
          name: 'data-volume',
          label: 'data-volume'
        },
        {
          name: 'data-forcerewind',
          label: 'data-forcerewind'
        },
        {
          name: 'data-nextslideatend',
          label: 'data-nextslideatend'
        },
        {
          name: 'data-videoloop',
          label: 'data-videoloop'
        },
        {
          name: 'data-videowidth',
          label: 'data-videowidth'
        },
        {
          name: 'data-videoheight',
          label: 'data-videoheight'
        },
        {
          name: 'data-forceCover',
          label: 'data-forceCover'
        },
        {
          name: 'data-aspectratio',
          label: 'data-aspectratio'
        },
        {
          name: 'data-autoplay',
          label: 'data-autoplay'
        },
        {
          name: 'data-autoplayonlyfirsttime',
          label: 'data-autoplayonlyfirsttime'
        }
      ]
    }
  },
  components: {
  },
  methods: {
    inputData (event, name) {
      this.value[name] = event
    }
  }
}
</script>
    
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/layer/VideoParameter.vue